module.exports = __webpack_public_path__ + "static/img/年度最佳烟机灶具.6a84a075.png";